// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__BAkFx","savePackageButton":"ClientWallet_savePackageButton__2rIel"};